export default __webpack_public_path__ + "static/media/star_off.545e0531.svg";